import React, {Component} from 'react';
import {Route, Switch} from "react-router-dom";
import {Helmet} from "react-helmet";
import {withBreadcrumb} from "../../Boilerplate/BreadcrumbContext";
import TaskList from "./TaskList";
import TaskNew from "./TaskNew";
import Task from "./Task";

class Tasks extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Tasks</title>
        </Helmet>
        <Switch>
          <Route component={TaskUi}/>
        </Switch>
      </div>
    );
  }
}

const TaskUi = () => (
  <div>
    <Route exact path="/projects/:id/tasks/" component={TaskList}/>
    <Switch>
      <Route path="/projects/:id/tasks/new" component={TaskNew}/>
      <Route path="/projects/:id/tasks/:taskId" component={Task}/>
    </Switch>
  </div>
);

export default withBreadcrumb(
  ({ match }) => ({ title: 'Tasks', path: `/projects/${match.params.id}/tasks/`}),
  Tasks
);



// WEBPACK FOOTER //
// ./src/components/Projects/Tasks/Tasks.js